import React, { useState, useEffect } from "react";
import Card from "../Card";
import {Toolbar } from "../../ui-components";
import ForAssignLeader from "./ForAssignLeader";
import AssignLeader from "./AssignLeader";
import DiscardedLeader from "./DiscardedLeader";
import Filters from "../../generalComponents/Filters";
import DetailLead from "../../generalComponents/DetailLead";
import UpdateLeadForm from "../../generalComponents/UpdateLeadForm";
import FollowManager from "./FollowManager";
import NoBranch from "./NoBranch";


const Leader = ({user, userName}) => {
  const [option, setOption] = useState(1);
  const [assingLead, setAssignLead] = useState();
  const [order, setOrder] = useState("1")
  const [canal, setCanal] = useState("0")
  const [asesor, setAsesor] = useState("0")
  const [branch, setBranch] = useState("El Pocito")
  
  const toggleTab = (index) => {
    setOption(index);
  };

  //console.log(user)
  const overridesToolbar = {
    ButtonUno: {
      backgroundColor: option === 1 && "#323977",
      onClick: () => toggleTab(1),
    },
    ButtonDos: {
      backgroundColor: option === 2 && "#323977",
      onClick: () => toggleTab(2),
    },
    ButtonTres: {
      backgroundColor: option === 3 && "#323977",
      onClick: () => toggleTab(3),
    },
    ButtonCuatro: {
        backgroundColor: option === 4 && "#323977",
        onClick: () => toggleTab(4),
    },
    ButtonCinco:{
      children:"SIN SUCURSAL",
      backgroundColor: option === 5 && "#323977",
        onClick: () => toggleTab(5),
    }
  };

 // console.log(option)
  return (
    <div className="mt-16">
     {option <= 5 && 
      (<Card
        textTitle="Leads Líder"
        elementBody={
          <div className="flex flex-col gap-6 px-6">
            <div className="flex justify-center">
              <Toolbar type={"leadleader"} width={"100%"} overrides={overridesToolbar}/>
            </div>
            <div>
              <Filters setorder={setOrder} order={order} canal={canal} setCanal={setCanal} asesor={asesor} setAsesor={setAsesor} user={user}/>
            </div>
            {option === 1 && (<div><ForAssignLeader setAssignLead={setAssignLead} onToggleTab={toggleTab} order={order} canal={canal} asesor={asesor}/> </div>)}
            {option === 2 && (<div><AssignLeader setAssignLead={setAssignLead} onToggleTab={toggleTab} order={order} canal={canal} asesor={asesor}/> </div>)}
            {option === 3 && (<div><DiscardedLeader setAssignLead={setAssignLead} onToggleTab={toggleTab} order={order} canal={canal} asesor={asesor}/></div>)}
            {option === 4 && (<div><FollowManager setAssignLead={setAssignLead} onToggleTab={toggleTab} order={order} canal={canal} asesor={asesor}/></div>)}
            {option === 5 && (<div><NoBranch setAssignLead={setAssignLead} onToggleTab={toggleTab} order={order} canal={canal} asesor={asesor}/></div>)}          
          </div>
        }
      />)  
    } 
      {option === 6 && <DetailLead assingLead={assingLead} onToggleTab={toggleTab}/>}
      {option === 7 &&<UpdateLeadForm assingLead={assingLead} onToggleTab={toggleTab} user={user} userName={userName}/>}
    </div>
  );
};

export default Leader;
